import {FC} from 'react';
import {DatePicker as SfDatePicker, Icons} from '@silverfort/sf-components';
import {LocalizationProvider} from '@mui/x-date-pickers';
import {AdapterMoment} from '@mui/x-date-pickers/AdapterMoment';
import moment from 'moment';
import {isDate} from 'lodash';

interface SingleDatePickerProps {
    value?: Date;
    onChange: (date?: Date) => void;
    className?: string;
}

const SingleDatePicker: FC<SingleDatePickerProps> = ({value, onChange, className = ''}) => {
    const sfDatePickerValue = value ? moment(value) : null;
    const isSelectedBeforeToday = value ? moment(value).isBefore(moment(), 'day') : false;

    const hasError = value && (!isDate(value) || isSelectedBeforeToday);

    const handleChange = (date: moment.Moment | null) => {
        onChange(date?.toDate());
    };

    // todo: remove LocalizationProvider and @mui/x-date-pickers from package.json after - https://silverfort.atlassian.net/browse/AF-36664
    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <SfDatePicker
                disablePast
                value={sfDatePickerValue}
                onChange={handleChange}
                className={className}
                slotProps={{
                    openPickerButton: {className: 'hover:!bg-transparent focus:!bg-transparent'},
                    openPickerIcon: {className: 'text-sf-gray-300', icon: Icons.Calendar},
                    textField: {
                        className: 'h-8',
                        inputProps: {
                            className: 'max-h-8 p-0 text-13'
                        },
                        InputProps: {
                            className:
                                'h-8 rounded-lg border-sf-gray-200 hover:border-sf-gray-400 [&.Mui-focused]:!border-sf-primary-500',
                            classes: {
                                notchedOutline: `${hasError ? '!border-sf-error' : '!border-inherit'} !border`
                            }
                        }
                    },
                    popper: {className: 'z-[5002]'}
                }}
            />
        </LocalizationProvider>
    );
};

export default SingleDatePicker;
